<template>
  <v-app>
    
    <v-main class="">
    <router-view />
  </v-main>
  <v-snackbar :color="snackbar.bg" top
    outlined  v-model="snackbar.status" :timeout="4000">
      {{ snackMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.color"
          text
          v-bind="attrs"
          @click="snackbar.status = false"
        >
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
</v-app>


</template>

<script>
import { mapGetters } from "vuex";
export default {
name: "App",

computed: {
  ...mapGetters(["snackbar", "snackMessage"]),
},
methods: {},
mounted() {},
data: () => ({
  //
}),
};
</script>

<style>
.v-main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  margin: 0;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  /* max-width: 100%; */
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}</style>